// 公開設定 — 可以 commit
// 環境變數透過 Vite 的 import.meta.env 讀（VITE_ 開頭才會曝露給前端）

const DEFAULT_PUBLIC_BASE = "https://pub-26cb42e42bdd4fb3af0b050237092ee7.r2.dev";
const DEFAULT_WORKER_BASE = "http://localhost:8787";

export const R2_PUBLIC_BASE =
  import.meta.env.VITE_R2_PUBLIC_BASE || DEFAULT_PUBLIC_BASE;

export const WORKER_BASE =
  import.meta.env.VITE_WORKER_BASE || DEFAULT_WORKER_BASE;

export const MANIFEST_URL = `${R2_PUBLIC_BASE}/manifest.json`;
